import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

const RabbitMqApiService = {
  init() {
    Vue.use(VueAxios, axios);
  },

  getSummary() {
    return Vue.axios.get("/api/ops/queues/summary");
  }
};

export default RabbitMqApiService;
